<template>
    <div class="category-display" :class="rootClasses" v-if="hasEntries">
        <component class="u-reset category-display--head" :href="headProps.href" :is="headProps.is">
            <div class="category-display--head-content">
                <h2 class="u-reset category-display--title">
                    {{ title }}
                </h2>
                <div class="category-display--arrow">
                    <ui-icon symbol="chevron-right" size="small"/>
                </div>
            </div>
        </component>
        <div class="category-display--body">
            <ul class="u-reset category-display--entry-teasers">
                <li class="category-display--entry-teaser" v-for="entry in entries" :key="entry.id">
                    <entry-teaser v-bind="entry"
                            :title-max-length="entryTitleMaxLength"
                            :parent-main-category-slug="parentMainCategorySlug"
                            :parent-sub-category-slug="parentSubCategorySlug"
                            :facets="entryFacets"/>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import EntryTeaser from 'framework/components/entry-teaser/entry-teaser';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import { RESOURCE_TYPES } from 'util/project/helpers';

    export default {
        components: {
            EntryTeaser,
            UiIcon,
        },
        mixins: [
            bemMixin('category-display'),
        ],
        inheritAttrs: false,
        props: {
            title: {
                type: String,
                default: null,
            },
            type: {
                type: String,
                required: true,
                validator: value => Object.values(RESOURCE_TYPES)
                    .includes(value),
            },
            id: {
                type: String,
                required: true,
            },
            slug: {
                type: String,
                required: true,
            },
            url: {
                type: String,
                default: null,
            },
            entryTitleMaxLength: {
                type: Number,
                required: true,
            },
            /** @type {IEntry[]} */
            entries: {
                type: Array,
                required: true,
            },
            /** @type {string[]} */
            mainCategoryIds: {
                type: Array,
                required: true,
            },
            /** @type {string[]} */
            entryFacets: {
                type: Array,
                default() {
                    return [];
                },
            },
        },
        computed: {
            ...mapGetters('project-data', ['activeRootCategory', 'getResourceById']),
            parentCategory() {
                const isRoot = this.type === RESOURCE_TYPES.ROOT;

                // We assume that a sub category has only one main category
                return isRoot ? this.activeRootCategory : this.getResourceById(this.mainCategoryIds[0]);
            },
            rootClasses() {
                return [
                    ...this.bemFacets,
                    this.bemAdd(`main-category-facet-${ this.parentCategory.color }`),
                    this.bemAdd(this.url ? 'has-category-link' : 'no-category-link'),
                ];
            },
            headProps() {
                return {
                    is: this.url ? 'a' : 'div',
                    href: this.url || null,
                };
            },
            hasEntries() {
                return !!this.entries.length;
            },
            parentMainCategorySlug() {
                return this.type === RESOURCE_TYPES.ROOT ? null : this.parentCategory.slug;
            },
            parentSubCategorySlug() {
                return this.type === RESOURCE_TYPES.ROOT ? null : this.slug;
            },
        },
    };
</script>
